import Button from "components/BaseWidgets/button";
import "./style.scss";
import { BackArrow } from "assets/icons";
import CardList from "./components/CardList";
import { useNavigate, useSearchParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import PaymentSuccess from "components/Account/components/PaymentSuccess/index ";

function Verification() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const status = searchParams.get("status"); // "0" | "1"
  const pin = searchParams.get("pin");
  const code = searchParams.get("code");

  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    if (status === "1") {
      setOpenModal(true);
    }
  }, [status]);
  return (
    <>
      <div className="container verification-container">
        <div className="flex items-center gap-3">
          <Button variant="custom" onClick={() => navigate("/my-profile")}>
            <BackArrow />
          </Button>
          <h1 className="font-title-lg fw-700 leading-3">
            Identity verification
          </h1>
        </div>
        <CardList />
        <PaymentSuccess
          pin={pin}
          code={code}
          status={status}
          open={openModal}
          onCancel={() => setOpenModal(false)}
          onOk={() => setOpenModal(false)}
          title="Verification successful"
          description="Your payment has been completed successfully. A unique verification code has been generated for you. Please save this code for future reference."
        />
      </div>
    </>
  );
}

export default Verification;
